import DataTable from "react-data-table-component"
import { useDispatch } from "react-redux"

import { orderDetailAction } from "../../Actions/orders"
import { Calendar, Eye, NavColor } from "../../HemeIconLibrary"

import Dropdown from "react-bootstrap/Dropdown"
import { NavDropdown } from "react-bootstrap"
import { setForm } from "../../Store/reducers/uiSettings"
import { setOrderDetail } from "../../Store/reducers/orders"
import { HemaValue, InfoIcon } from "../../utils"
const OrderDataTable = ({ data }) => {
  const dispatch = useDispatch()
  const customStyles = {
    style: {
      border: "1px solid #DEE2E6",
    },
    headCells: {
      style: {
        backgroundColor: "#F9F4FF",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "24px",
        borderLeft: "1px solid #DEE2E6",
        borderTop: "1px solid #DEE2E6",
      },
    },
    cells: {
      style: {
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: "20px",
        color: "#595959",
        borderLeft: "1px solid #DEE2E6",
      },
    },
  }
  return data.length > 0 ? (
    <div className="border-r-[1px] border-b-[1px] border-solid border-[#DEE2E6] order-history-table">
      <DataTable
        customStyles={customStyles}
        data={data}
        columns={[
          {
            center: true,
            name: "Order Confirmation #",
            selector: (row) => <div className="">{row?.orderCode}</div>,
          },
          {
            center: true,
            name: "Submitted By",
            style: {
              overflow: "hidden !important",
            },
            selector: (row) => (
              <div className="w-full overflow-hidden">{row?.requesterName}</div>
            ),
          },
          {
            center: true,
            name: "Order Date",
            selector: (row) => {
              return (
                <div className="flex items-center gap-1">
                  <Calendar /> {row?.createdUtc?.split("T")[0]}
                </div>
              )
            },
          },
          {
            center: true,
            name: "Status",
            style: {
              "data-tag=allowRowEvents": { width: "100%" },
            },
            selector: (row) => {
              return (
                <div
                  className={`flex items-center w-fit gap-1 cursor-pointer px-2 py-1 rounded-full ${(row?.status?.name === "New" && "bg-[#E6F2F6]") ||
                    (row?.status?.name === "In Process" && "bg-[#F6EEE6]") ||
                    (row?.status?.name === "Shipped" && "bg-[#F6E6F2]") ||
                    (row?.status?.name === "Delivered" && "bg-[#E6F6EB]") ||
                    (row?.status?.name === "Rejected" && "bg-[#f5e2e1]")
                    }`}
                >
                  <div
                    className={`w-2 h-2 rounded-full ${(row?.status?.name === "New" && "bg-[#06B6D4]") ||
                      (row?.status?.name === "In Process" && "bg-[#F97316]") ||
                      (row?.status?.name === "Shipped" && "bg-[#C92286]") ||
                      (row?.status?.name === "Delivered" && "bg-[#065528]") ||
                      (row?.status?.name === "Rejected" && "bg-[#f50b0b]")
                      }`}
                  />

                  <HemaValue
                    className="text-[12px] leading-[18px]"
                    color={
                      (row?.status?.name === "New" && "text-[#06B6D4]") ||
                      (row?.status?.name === "In Process" &&
                        "text-[#F97316]") ||
                      (row?.status?.name === "Shipped" && "text-[#C92286]") ||
                      (row?.status?.name === "Delivered" && "text-[#065528]") ||
                      (row?.status?.name === "Rejected" && "text-[#f50b0b]")
                    }
                    text={row?.status?.name}
                  />
                  {row?.status?.name === "In Process" && row?.shippedPackagesCount>0 && 
                  <InfoIcon
                  tooltip={`Some shipments have been shipped`} 
                  />}
                </div>
              )
            },
            sortable: true,
          },
          {
            center: true,
            width: "80px",
            selector: (row) => {
              return (
                <NavDropdown
                  title={<NavColor />}
                  id="nav-dropdown"
                  className="cursor-pointer w-9 h-9 flex items-center justify-center bg-[#F9F4FF] rounded-full order-history-dropdown"
                >
                  <NavDropdown.Item
                    onClick={async () => {
                      dispatch(setOrderDetail(null))
                      orderDetailAction(row.id, row.site.id)
                      dispatch(
                        setForm({ state: true, type: "order-detail-form" })
                      )
                    }}
                    className="w-fit"
                    href=""
                  >
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-normal text-subheadingColor">
                        View Order Details
                      </span>
                    </div>
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={async () => {
                      dispatch(setOrderDetail(null))
                      orderDetailAction(row.id, row.site.id)
                      dispatch(
                        setForm({ state: true, type: "order-detail-shipment" })
                      )
                    }}
                    className="w-fit"
                    href=""
                  >
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-normal text-subheadingColor">
                        View Shipment Information
                      </span>
                    </div>
                  </NavDropdown.Item>
                </NavDropdown>
              )
            },
          },
        ]}
      />
    </div>
  ) : (
    <p className="">data not found</p>
  )
}
export default OrderDataTable
